var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSheetAnnotations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.0397 56.7344L69.1393 124.177L136.522 130.072L142.422 62.6296L75.0397 56.7344Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.499995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 30.5C9.02611 27.5111 10.225 24.652 12.3385 22.5385C14.4521 20.425 17.3111 19.2261 20.3 19.2C22.1898 19.1993 24.0485 19.6812 25.7 20.6V90.1C24.0485 89.1812 22.1898 88.6993 20.3 88.7C17.3111 88.7261 14.4521 89.925 12.3385 92.0385C10.225 94.152 9.02611 97.0111 9 100V30.5Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.499995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.3 114.7C117.3 115.6 118.1 116.3 119.3 116.4C120.5 116.5 121.4 116 121.4 115.1C121.4 114.2 121 113.9 119.9 113.5L118.9 113.1C117.3 112.6 116.7 111.8 116.8 110.7C116.9 109.6 118.2 108.4 120 108.5C120.726 108.5 121.423 108.781 121.945 109.284C122.468 109.788 122.774 110.475 122.8 111.2H121.7C121.7 110.3 121 109.7 119.9 109.6C118.8 109.5 118 110 117.9 110.8C117.8 111.6 118.3 111.9 119.4 112.3L120.3 112.6C122 113.2 122.7 114 122.6 115.2C122.5 116.4 121.1 117.6 119.1 117.4C118.729 117.428 118.356 117.378 118.005 117.255C117.654 117.132 117.332 116.937 117.06 116.684C116.788 116.43 116.571 116.123 116.423 115.782C116.275 115.44 116.199 115.072 116.2 114.7H117.3Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.166665,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.9 123C125.533 123 130.1 118.433 130.1 112.8C130.1 107.167 125.533 102.6 119.9 102.6C114.267 102.6 109.7 107.167 109.7 112.8C109.7 118.433 114.267 123 119.9 123Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6 88.0998C82.0879 88.0605 81.5885 87.9206 81.1304 87.6882C80.6723 87.4558 80.2645 87.1354 79.9302 86.7454C79.5959 86.3554 79.3417 85.9034 79.1821 85.4151C79.0225 84.9269 78.9607 84.412 79 83.8999C79.0394 83.3877 79.1793 82.8883 79.4117 82.4302C79.6441 81.9721 79.9645 81.5643 80.3545 81.23C80.7445 80.8957 81.1965 80.6415 81.6847 80.4819C82.173 80.3223 82.6879 80.2605 83.2 80.2999",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4 78C82.3657 77.9072 81.4106 77.4073 80.7448 76.6102C80.0791 75.8132 79.7572 74.7844 79.85 73.75C79.9429 72.7157 80.4428 71.7606 81.2398 71.0948C82.0368 70.4291 83.0657 70.1072 84.1 70.2",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M113 72.7C114.034 72.7928 114.989 73.2927 115.655 74.0897C116.321 74.8868 116.643 75.9156 116.55 76.95C116.457 77.9843 115.957 78.9394 115.16 79.6052C114.363 80.2709 113.334 80.5928 112.3 80.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M112.1 82.8999C113.022 83.109 113.836 83.6457 114.392 84.4102C114.948 85.1747 115.207 86.1151 115.121 87.0564C115.036 87.9977 114.611 88.8759 113.927 89.5277C113.242 90.1794 112.344 90.5605 111.4 90.5999",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1 70.1999C84.1459 69.6878 84.2923 69.1897 84.5308 68.7341C84.7692 68.2785 85.0951 67.8744 85.4897 67.5448C85.8844 67.2151 86.3401 66.9664 86.8309 66.8129C87.3216 66.6593 87.8378 66.604 88.35 66.65C88.8621 66.6959 89.3602 66.8423 89.8158 67.0808C90.2714 67.3192 90.6755 67.6451 91.0052 68.0397C91.3348 68.4344 91.5835 68.8901 91.737 69.3808C91.8906 69.8716 91.9459 70.3878 91.9 70.9",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3 71.0999C94.338 70.5872 94.4769 70.0871 94.7088 69.6283C94.9407 69.1695 95.261 68.761 95.6513 68.4264C96.0417 68.0919 96.4943 67.8378 96.9832 67.6788C97.4721 67.5198 97.9876 67.459 98.5 67.4999C99.5441 67.6015 100.506 68.1091 101.18 68.9134C101.853 69.7177 102.184 70.7543 102.1 71.7999",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.4 71.9999C104.439 71.4878 104.579 70.9884 104.812 70.5303C105.044 70.0722 105.364 69.6644 105.754 69.3301C106.144 68.9958 106.596 68.7416 107.085 68.582C107.573 68.4224 108.088 68.3606 108.6 68.3999C109.112 68.4393 109.612 68.5792 110.07 68.8116C110.528 69.044 110.936 69.3644 111.27 69.7544C111.604 70.1444 111.858 70.5964 112.018 71.0846C112.178 71.5729 112.239 72.0878 112.2 72.5999",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M110.6 90.5999C110.499 91.6174 110.002 92.5544 109.216 93.2091C108.43 93.8637 107.419 94.1836 106.4 94.0999C105.887 94.062 105.387 93.9231 104.928 93.6912C104.47 93.4593 104.061 93.1389 103.726 92.7486C103.392 92.3583 103.138 91.9056 102.979 91.4168C102.82 90.9279 102.759 90.4124 102.8 89.8999",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M100.5 89.7C100.376 90.7161 99.8757 91.6489 99.0985 92.315C98.3213 92.9812 97.3231 93.3325 96.3 93.3C95.778 93.2627 95.2689 93.1206 94.803 92.8824C94.3371 92.6442 93.9239 92.3147 93.588 91.9135C93.2521 91.5123 93.0004 91.0476 92.8478 90.547C92.6952 90.0465 92.6449 89.5204 92.6999 89",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4 88.7999C90.3541 89.312 90.2077 89.8101 89.9692 90.2657C89.7308 90.7213 89.4049 91.1254 89.0103 91.4551C88.6156 91.7847 88.1599 92.0334 87.6691 92.1869C87.1784 92.3405 86.6622 92.3958 86.15 92.3499C85.6379 92.3039 85.1398 92.1575 84.6842 91.919C84.2286 91.6806 83.8245 91.3547 83.4948 90.9601C83.1652 90.5654 82.9165 90.1097 82.763 89.619C82.6094 89.1282 82.5541 88.612 82.6 88.0999",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4001 94.7H40.3V46.5H54.5",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1 46.5H105.1V52.8",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3 51V44.5",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4 68.3999H55",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M64 109.4H20.5C19.1258 109.4 17.7652 109.128 16.4968 108.599C15.2285 108.07 14.0775 107.295 13.1105 106.319C12.1434 105.342 11.3795 104.184 10.8627 102.911C10.346 101.637 10.0868 100.274 10.1 98.8999",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7 31.8999H119.7V54.4999",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M129.4 98.2999L132.8 60.0999",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7 84.3L128.4 89.3",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M126.6 130.7L127.8 116.9",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheetAnnotations);
export default __webpack_public_path__ + "static/media/sheet_annotations.57ef76fc084c4e9e0ea6dac81cfbc76c.svg";
export { ForwardRef as ReactComponent };